<template>
	<component class="oedf5" :is="tag">
		<slot></slot>
	</component>
</template>

<script>
export default {
	name: "j-headline",
	props: {
		tag: {
			type: String,
			required: false,
			default: "h1"
		}
	}
}
</script>

<style src="./index.css" scoped />
